import axios from 'axios';

/**
 * Authentication is carried by the server side session cookie, so every request has to be sent
 * with credentials and has to echo the csrf cookie back as a header.
 */
const Axios = axios.create({
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

export default Axios;
